import React, {useState} from "react";
import CompanyLogo from "../CompanyLogo";
import RandomLogo from "../RandomLogo";
import { Link ,useLocation} from "react-router-dom";
import { routeNames } from "../../routeSegments";
import useModule from "../../hooks/useModule";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "antd";


/* The above code is a React component called `InvestorInfo`. It takes two props, `props` and `menu`. */
const EXIT_STATUS_LABELS = {
  0: "",
  1: "Partial",
  2: "Complete",
};

const InvestorInfo = (props ,menu) => {
  // const location = useLocation();
  const [expandedRow, setExpandedRow] = useState(new Set());

  const {isPE} = useModule()

  const hasStakeHeld = props?.data?.some(
    (d) => d.investor_stake_held && parseFloat(d.investor_stake_held) !== 0
  );
  const hasExitStatus = props?.data?.some(
    (d) => EXIT_STATUS_LABELS[d.investor_exit_status]
  );

  // const hasInvestedAmount = props?.data?.some(
  //   (d) => d.invested_amount_inr && parseFloat(d.invested_amount_inr) !== 0
  // );
  // const hasRealisedAmount = props?.data?.some(
  //   (d) => d.realised_amount_inr && parseFloat(d.realised_amount_inr) !== 0
  // );
  // const hasUnrealisedAmount = props?.data?.some(
  //   (d) => d.unrealised_amount_inr && parseFloat(d.unrealised_amount_inr) !== 0
  // );

    const toggleRow = (index) => {
        setExpandedRow(prev => {
        const newSet = new Set(prev);
        if (newSet.has(index)) {
            newSet.delete(index);
        } else {
            newSet.add(index);
        }
        return newSet;
        });
    };

 /* The `getExitDetailReturnRow` function is a helper function that returns a JSX element representing
 a table row (`<tr>`) in the InvestorInfo component. */
  const getExitDetailReturnRow = (exitDetailReturnData, index) => (
    <React.Fragment key={index}>
      <tr className="border-b">
        <td className="whitespace-nowrap font-medium py-4 px-5 text-left w-[40%]">
          <div className="leading-8">
            {exitDetailReturnData.logo_path == "default.png" ||
              exitDetailReturnData.logo_path == "/default.png" ||
              !exitDetailReturnData.logo_path ? (
              <RandomLogo name={exitDetailReturnData.investor_name} />
            ) : (
              <CompanyLogo
                name={exitDetailReturnData.investor_name}
                page="company page"
                logo={exitDetailReturnData.logo_path}
              />
            )}
              {exitDetailReturnData?.investor_name && exitDetailReturnData?.investor_name === "Others" ? (
                  <span>{exitDetailReturnData?.investor_name}</span> 
              ) : (
                <Link
                  to={isPE ? routeNames.peInvestorById(exitDetailReturnData.investor_id) : routeNames.vcInvestorById(exitDetailReturnData.investor_id)}
                  className="hover:text-[#BC8B20] text-[#333333]">
                  {exitDetailReturnData?.investor_name}
                </Link>
              )}

               {exitDetailReturnData?.fund_details?.length > 0 && (
                  <button onClick={() => toggleRow(index)} className="ml-2 text-lg">
                      {expandedRow.has(index) ? '-' : '+'}
                  </button>
                )}
          </div>      
        </td>
        <td className="whitespace-nowrap py-4 px-5 text-center w-[8%]">
          {exitDetailReturnData.amount_usd
            ? parseFloat(exitDetailReturnData.amount_usd).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : " "}
        </td>
        <td className="whitespace-nowrap py-4 px-5 text-center w-[8%]">
          {exitDetailReturnData.amount_inr
            ? parseFloat(exitDetailReturnData.amount_inr).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            : " "}
        </td>
        <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
          {exitDetailReturnData.investor_stake_sold && exitDetailReturnData.investor_stake_sold != 0
            ? parseFloat(exitDetailReturnData.investor_stake_sold).toFixed(2) + "%"
            : " "}
        </td>
        {hasStakeHeld && (
          <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
            {exitDetailReturnData.investor_stake_held && exitDetailReturnData.investor_stake_held != 0
              ? parseFloat(exitDetailReturnData.investor_stake_held).toFixed(2) + "%"
              : " "}
          </td>
        )}
        <td className="whitespace-nowrap py-4 px-5 text-center w-[14%]">
          {exitDetailReturnData.multiple_return && exitDetailReturnData.multiple_return !== 0 ? (
            exitDetailReturnData?.more_info && exitDetailReturnData.more_info.trim() !== "" ? (
              <Tooltip
                placement="top"
                color="#ffffff"
                key="#ffffff"
                overlayStyle={{ maxWidth: '30%' }}
                title={<span style={{ color: '#000000' }}>{exitDetailReturnData?.more_info}</span>}>
                <div className="text-center text-[#BC8B20] cursor-help">{exitDetailReturnData.multiple_return + "x"}</div>
              </Tooltip>
            ) : (
              <div>{exitDetailReturnData.multiple_return + "x"}</div>
            )
          ) : (
            " "
          )}
        </td>
        <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
          {exitDetailReturnData.irr && exitDetailReturnData.irr !== 0 ?
            <div >{parseFloat(exitDetailReturnData.irr).toFixed(2) + "%"}

            </div>
            : " "}
        </td>
        {hasExitStatus && (
          <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
            {EXIT_STATUS_LABELS[exitDetailReturnData.investor_exit_status] ?? " "}
          </td>
        )}
        {/* {hasInvestedAmount && (
          <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
            {exitDetailReturnData.invested_amount_inr
              ? parseFloat(exitDetailReturnData.invested_amount_inr).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : " "}
          </td>
        )}
        {hasRealisedAmount && (
          <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
            {exitDetailReturnData.realised_amount_inr
              ? parseFloat(exitDetailReturnData.realised_amount_inr).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : " "}
          </td>
        )}
        {hasUnrealisedAmount && (
          <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
            {exitDetailReturnData.unrealised_amount_inr
              ? parseFloat(exitDetailReturnData.unrealised_amount_inr).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              : " "}
          </td>
        )} */}
      </tr>

      {/* Conditionally render fund details if expanded */}
      {expandedRow.has(index) && exitDetailReturnData?.fund_details?.length > 0 && (
        exitDetailReturnData?.fund_details?.map((fund, idx) => (
          <tr key={idx} className="border-b">
            <td className="whitespace-nowrap font-medium py-4 px-5 text-left w-[40%]">
              <div className="leading-8 flex items-center ml-12 hover:text-[#BC8B20]">
                <Link to={routeNames.fundById(fund.fundId)}>
                  {fund.fundName}
                </Link>
              </div>
            </td>
            <td className="whitespace-nowrap py-4 px-5 text-center w-[8%]">
              {fund.amount_m && fund.amount_m !== "0.00"
                ? parseFloat(fund.amount_m).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : " "}
            </td>
            <td className="whitespace-nowrap py-4 px-5 text-center w-[8%]">
              {fund.amount_inr && fund.amount_inr !== "0.00"
                ? parseFloat(fund.amount_inr).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : " "}
            </td>
            <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
              {fund.stake_sold && fund.stake_sold != 0
                ? parseFloat(fund.stake_sold).toFixed(2) + "%"
                : " "}
            </td>
            {hasStakeHeld && (
              <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
                {fund.stake_held && fund.stake_held != 0
                  ? parseFloat(fund.stake_held).toFixed(2) + "%"
                  : " "}
              </td>
            )}
            <td className="whitespace-nowrap py-4 px-5 text-center w-[14%]">
              {fund.return_multiple && fund.return_multiple !== "0.00" ? (
                fund?.investment_more_info && fund.investment_more_info.trim() !== "" ? (
                  <Tooltip
                    placement="top"
                    color="#ffffff"
                    key="#ffffff"
                    overlayStyle={{ maxWidth: '30%' }}
                    title={<span style={{ color: '#000000' }}>{fund?.investment_more_info}</span>}>
                    <div className="text-center text-[#BC8B20] cursor-help">{parseFloat(fund.return_multiple).toFixed(2) + "x"}</div>
                  </Tooltip>
                ) : (
                  <div>{parseFloat(fund.return_multiple).toFixed(2) + "x"}</div>
                )
              ) : (
                " "
              )}
            </td>
            <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
              {fund.irr && fund.irr !== "0.00" ? (
                <div>{parseFloat(fund.irr).toFixed(2) + "%"}</div>
              ) : (
                " "
              )}
            </td>
            {hasExitStatus && (
              <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
                {EXIT_STATUS_LABELS[fund.exit_status] ?? " "}
              </td>
            )}
            {/* {hasInvestedAmount && (
              <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
                {fund.total_amount_invested_inr
                  ? parseFloat(fund.total_amount_invested_inr).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                  : " "}
              </td>
            )}
            {hasRealisedAmount && (
              <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
                {fund.total_amount_realised_inr
                  ? parseFloat(fund.total_amount_realised_inr).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                  : " "}
              </td>
            )}
            {hasUnrealisedAmount && (
              <td className="whitespace-nowrap py-4 px-5 text-center w-[10%]">
                {fund.total_amount_unrealised_inr
                  ? parseFloat(fund.total_amount_unrealised_inr).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                  : " "}
              </td>
            )} */}
          </tr>
        ))
      )}
    </React.Fragment>
  );

  return (
    <div className="lg:grid lg:grid-rows-8 gap-6">
      <div className="w-full lg:grid lg:grid-rows-8 lg:grid-flow-col overflow-x-auto scrollbar ">
        <div className="row-span-3">
          <div className="">
            <div className="row-span-1">
              {props?.data ? (
                props?.data?.length > 0 ? (
                  <table className="w-full mx-auto mt-2 flex-shrink-0">
                    <thead className=" text-[12pt] leading-[15pt] bg-[#F3F3F3] lg:text-[13px] lg:leading-[15px] font-semibold text-[#666666] whitespace-nowrap">
                      <tr>
                        <th className="py-2 px-5 text-left whitespace-nowrap w-[40%]">
                          Investor Name
                        </th>
                        <th className="whitespace-nowrap py-2 px-5 w-[8%] text-center">
                          Amount($M)
                        </th>
                        <th className="whitespace-nowrap py-2 px-5 w-[8%] text-center">
                          Amount(INR Cr)
                        </th>
                        <th className="whitespace-nowrap py-2 px-5 w-[10%] text-center">
                          Stake Sold
                        </th>
                        {hasStakeHeld && (
                          <th className="whitespace-nowrap py-2 px-5 w-[10%] text-center">
                            Stake Held
                          </th>
                        )}
                        <th className="whitespace-nowrap py-2 px-5 w-[14%] text-center">
                          Return Multiple
                        </th>
                        <th className="whitespace-nowrap py-2 px-5 w-[10%] text-center">
                          IRR
                        </th>
                        {hasExitStatus && (
                          <th className="whitespace-nowrap py-2 px-5 w-[10%] text-center">
                            <span className="inline-flex items-center justify-center gap-1">
                              Exit Status
                              <Tooltip
                                color="#ffffff"
                                key="#ffffff"
                                overlayStyle={{ maxWidth: '30%'  }}
                                placement="left"
                                title={<span style={{ color: '#000000' }}>Treated as Completely Exited when investor stake in a Listed Company dips below 1% </span>}
                              >
                                <FaInfoCircle size={12} color="grey"/>
                              </Tooltip>
                            </span>
                          </th>
                        )}
                        {/* {hasInvestedAmount && (
                          <th className="whitespace-nowrap py-2 px-5 w-[10%] text-center">
                            Total Invested (INR Cr)
                          </th>
                        )}
                        {hasRealisedAmount && (
                          <th className="whitespace-nowrap py-2 px-5 w-[10%] text-center">
                            Total Realised (INR Cr)
                          </th>
                        )}
                        {hasUnrealisedAmount && (
                          <th className="whitespace-nowrap py-2 px-5 w-[10%] text-center">
                            Total Unrealised (INR Cr)
                          </th>
                        )} */}
                      </tr>
                    </thead>
                    {/* {props?.data? */}
                    <tbody className="text-[12pt] leading-[16pt] lg:text-[14px] lg:leading-[16px] font-sans_book_body text-[#333333] ">
                      {props?.data.map((value, index) => {
                        return getExitDetailReturnRow(value, index);
                      })}
                    </tbody>

                  </table>
                ) : (
                  <div className="flex items-center justify-center w-full px-5">
                      <p className="p-3 my-3 mx-auto text-[14px] text-[#333333] text-center leading-[16px] font-sans_book_body w-full">No data available</p>
                  </div>
                )
              ) : (
                <div className="w-full bg-[#FFFFFF]">
                  <center>
                    <div role="status" className=" h-[7rem]">
                      <svg
                        className="relative left-[0rem] top-[3rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  </center>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestorInfo;
